<template>
  <div class="filter-container">
    <div class="filter-group">
      <select 
        v-if="isSortingOptions"
        v-model="selectedCriteria"
        @change="handleFilterChange"
        class="filter-select"
      >
        <option value="" disabled>{{ dafaultNoneOption }}</option>
        <option 
          v-for="option in sortingOptions" 
          :key="option.value" 
          :value="option.value"
        >
          {{ option.label }}
        </option>
      </select>

      <select 
        v-if="isOrderOptions"
        v-model="selectedOrder"
        @change="handleFilterChange"
        class="filter-select"
      >
        <option 
          v-for="order in orderOptions" 
          :key="order.value" 
          :value="order.value"
        >
          {{ order.label }}
        </option>
      </select>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterComponent',
  props: {
    sortCriteria: {
      type: String,
      default: 'name'
    },
    sortOrder: {
      type: String,
      default: 'asc'
    },
    isSortingOptions: {
      type: Boolean,
      default: true
    },
    sortingOptions: {
      type: Array,
      required: true
    },
    isOrderOptions: {
      type: Boolean,
      default: false
    },
    orderOptions: {
      type: Array,
      required: false
    },
    dafaultNoneOption: {
      type: String,
      default: 'Sort By',
      required: false,
    }
  },
  data() {
    return {
      selectedCriteria: this.sortCriteria,
      selectedOrder: this.sortOrder
    }
  },
  methods: {
    handleFilterChange() {
      this.$emit('filter-change', {
        criteria: this.selectedCriteria,
        order: this.selectedOrder
      })
    }
  }
}
</script>

<style scoped>
.filter-container {
  /* padding: 1rem;
  background-color: #f5f5f5;
  border-radius: 8px;
  margin-bottom: 1rem; */
}

.filter-group {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
}

.filter-select {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 8px;
  background-color: white;
  font-size: 14px;
  cursor: pointer;
  min-width: 120px;
}

.filter-select:focus {
  outline: none;
  border-color: var(--logo-color);
}
@media (max-width: 1152px) {
  .filter-group {
    width: 100%;
  }
  .filter-select {
    width: 100%;
  }
}
</style>